<template>
  <card-seplag titulo="Gestão de Licença Premio">
    <div class="divBusca p-col-12">
      <div class="p-grid p-align-end p-justify-center">
        <Rotulo cols="12 6" nome="Orgão">
          <Dropdown
            v-model="orgaoSelecionado"
            :options="listaOrgao"
            optionLabel="labelDropDaw"
            placeholder="Selecione..."
            filter
            :disabled="listaOrgao.length == 0"
            @change="clicouOrgao()"
          />
        </Rotulo>
        <Rotulo cols="12 6" nome="Setor:">
          <Dropdown
            v-model="unidadeSelecionado"
            :options="listaUnidades"
            optionLabel="labelDropDaw"
            placeholder="Selecione..."
            filter
            :showClear="!!unidadeSelecionado"
            :disabled="!orgaoSelecionado || listaUnidades.length == 0"
          />
        </Rotulo>
        <Rotulo cols="12 6" nome="Servidor">
          <InputText
            type="text"
            v-model="filtro"
            placeholder="Informe a matrícula ou nome do Servidor"
          />
        </Rotulo>
        <Rotulo cols="12 4" nome="Situação">
          <Dropdown
            v-model="situacaoSelecionada"
            :options="situacoes"
            optionLabel="label"
            placeholder="Selecione..."
            showClear
          />
        </Rotulo>
        <div class="p-md-2 p-col-12">
          <Button
            label="Buscar"
            icon="pi pi-search"
            class="p-button-info"
            @click="clicouBuscar()"
          />
        </div>
      </div>
    </div>
    <div
      class="p-col-12"
      v-if="
        listaServidores &&
        listaServidores.content &&
        listaServidores.content.length > 0
      "
    >
      <!-- :onSearchPaginacao="carregarDadosAgendamento" -->
      <table-seplag
        :dados="listaServidores.content"
        :exibirCabecalho="false"
        :campos="[]"
        :paginacao="true"
        :totalRegistro="listaServidores.totalElements"
        :onSearchPaginacao="carregarServidores"
      >
        <Column field="matricula" header="Matrícula">
          <template #body="slotProps">
            <p>{{ slotProps.data.matricula }}</p>
          </template>
        </Column>
        <Column
          field="dataInicioPeriodoAquisitivo"
          header="Quinquênio"
          headerClass="situacaoColunaFeriasAgendamento"
          bodyClass="botaoColunaSituacaoFeriasAgendamento"
        >
          <template #body="slotProps">
            <span>
              {{ slotProps.data.dataInicioPeriodoAquisitivo }} à
              {{ slotProps.data.dataFimPeriodoAquisitivo }}</span
            >
          </template>
        </Column>
        <Column
          field="dataInicio"
          header="Data Início"
          headerClass="situacaoColunaFeriasAgendamento"
          bodyClass="botaoColunaSituacaoFeriasAgendamento"
        >
          <template #body="slotProps">
            <span>{{ slotProps.data.dataInicio }}</span>
          </template>
        </Column>
        <Column
          field="dataFim"
          header="Data Término"
          headerClass="situacaoColunaFeriasAgendamento"
          bodyClass="botaoColunaSituacaoFeriasAgendamento"
        >
          <template #body="slotProps">
            <span>{{ slotProps.data.dataFim }}</span>
          </template>
        </Column>
        <Column field="origem" header="Origem">
          <template #body="slotProps">
            <p>{{ slotProps.data.origem }}</p>
          </template>
        </Column>
        <Column
          field="status"
          header="Situação"
          headerClass="situacaoColunaFeriasAgendamento"
          bodyClass="botaoColunaSituacaoFeriasAgendamento"
        >
          <template #body="slotProps">
            <Button
              :label="slotProps.data.status"
              :class="
                'p-button-outlined customer-badge status-' +
                slotProps.data.status
              "
              @click="mostrarDetalhes(slotProps.data)"
            />
          </template>
        </Column>
        <Column field="aprovador" header="Aprovador">
          <template #body="slotProps">
            <div class="colunaAprovador">
              <span>{{ aprovadorNome(slotProps.data) }}</span><br />
              <span>{{ aprovadorSetor(slotProps.data) }}</span>
            </div>
          </template>
        </Column>
        <Column
          headerStyle="width: 6em"
          bodyStyle="text-align: center;"
          header="Ação"
        >
          <template #body="slotProps">
            <Button
              type="button"
              icon="pi pi-id-card"
              v-tooltip.top="'Ação'"
              @click="showModal(slotProps.data)"
              :disabled="false"
              v-if="exibirBotaoAcao(slotProps.data)"
            ></Button>
          </template>
        </Column>
      </table-seplag>
    </div>
    <!-- MODAL DE APROVAÇÃO -->
    <cadastro-rapido
      v-if="habilitaAgendamento"
      :tituloTela="mostrarDeferidos ? 'Indeferir Férias' : 'Definir Ação'"
      v-model="exibirModalAprovacao"
      :modoEdicao="'adicionar'"
      :onAdicionar="validaRejeitaPedido"
      @fechar-modal="fecharModalValidaEscala"
      :textoButton="mostrarDeferidos ? 'Indeferir' : 'Salvar'"
    >
      <div class="p-col-12">
        <Fieldset v-if="servidorAprovacao">
          <template #legend>
            <strong>Servidor</strong>
          </template>
          <p>
            <strong>Matricula: </strong>
            {{ servidorAprovacao.matricula ? servidorAprovacao.matricula : "" }}
            - <strong>Vinculo: </strong>
            {{
              servidorAprovacao.numeroVinculo
                ? servidorAprovacao.numeroVinculo
                : ""
            }}
          </p>
          <p>
            <strong>Candidato: </strong>
            {{ servidorAprovacao.nome ? servidorAprovacao.nome : "" }}
          </p>
          <p>
            <strong>Periodo de Usufruto: </strong>
            {{
              servidorAprovacao.dataInicio ? servidorAprovacao.dataInicio : ""
            }}
            à {{ servidorAprovacao.dataFim ? servidorAprovacao.dataFim : "" }}
          </p>
          <p v-if="servidorAprovacao.dataInicioTemporario">
            <strong>Alterado para </strong
            >{{ servidorAprovacao.dataInicioTemporario }} à
            {{ servidorAprovacao.dataFimTemporario }}
          </p>
        </Fieldset>
      </div>
      <Rotulo nome="Deferido" cols="12" v-if="!mostrarDeferidos">
        <SelectButton
          name="deferido"
          v-model="registro.statusProgramacao"
          :options="simNao"
          optionLabel="name"
          v-required
        />
      </Rotulo>
      <Rotulo
        nome="Motivo Rejeição:"
        cols="12"
        v-if="registro.statusProgramacao.code == 'N'"
      >
        <Dropdown
          name="motivoRejeicao"
          v-model="registro.motivoRejeicao"
          :options="motivoRejeicao"
          v-required
        />
      </Rotulo>
      <Rotulo nome="Justificativa:" cols="12">
        <Textarea v-model="registro.observacao" rows="5" cols="30" />
      </Rotulo>
    </cadastro-rapido>

    <!--Modal Detalhes-->
    <cadastro-rapido
      tituloTela="Detalhes"
      :tamanhoTela="'30.vw'"
      v-model="exibirDetalhes"
      textoButtonFechar="Fechar"
      :visivelbotao="true"
    >
      <p
        style="text-align: justify"
        v-html="detalhes ? detalhes : 'Não Informado'"
      />
    </cadastro-rapido>
  </card-seplag>
</template>

<script>
import CadastroRapido from "@/template/CadRapidoSeplag.vue";
import CardSeplag from "@/template/CardSeplag.vue";
import TableSeplag from "@/template/TableSeplag.vue";
import { baseApiUrl, simNao } from "@/config/global";
import Rotulo from "@/template/RotuloSeplag.vue";
import moment from "moment";

const getDefaulValida = () => {
  return {
    matriculaValidador: null,
    numeroVinculoValidador: null,
    idReg: null,
    proximaSituacao: null,
    chavePeriodoAquisitivo: null,
    motivoRejeicao: null,
    chavePend: null,
    observacao: null,
    statusProgramacao: { name: "Não", code: "N" },
  };
};

export default {
  name: "feriasChefiaPendenteValidacao",
  components: { CardSeplag, Rotulo, TableSeplag, CadastroRapido },
  data: function () {
    return {
      listaOrgao: [],
      listaUnidades: [],
      orgaoSelecionado: null,
      unidadeSelecionado: null,
      listaServidores: [],

      situacoes: [
        { label: "Pendente", value: "PENDENTE" },
        { label: "Validado", value: "APROVADO" },
        { label: "Reprovado", value: "REPROVADO" },
      ],
      situacaoSelecionada: null,
      situacaoConsultada: null,
      tituloTabela: "",

      //Filtro
      filtro: null,

      //usuario
      matricula: parseInt(this.$store.getters.getMatricula),
      vinculo: parseInt(this.$store.getters.getVinculo),

      //Detalhamento
      exibirDetalhes: false,
      detalhes: null,

      //Modal Aprovacao
      exibirModalAprovacao: false,
      servidorAprovacao: null,
      habilitaAgendamento: true,
      simNao: simNao,
      registro: getDefaulValida(),
      motivoRejeicao: [],

      //not used
      // dadosTabelaValidados: [],
      // apiUrlRecurso: "feriasview",
      // urlPaginacao: null,
      // totalRegistro: 0,
      // tamanhoPorpagina: 1000,
      // paginacaoTabela: '?size=1000&page=0',
    };
  },
  watch: {
    exibirModalAprovacao(novoValor, valorAntigo) {
      // O modal foi fechado se o novo valor for false e o valor antigo for true.
      if (novoValor === false && valorAntigo === true) {
        this.fecharModalValidaEscala();
      }
    },
  },
  methods: {
    validaRejeitaPedido() {
      this.registro.matriculaValidador = this.$store.getters.getMatricula;
      this.registro.numeroVinculoValidador = this.$store.getters.getVinculo;
      this.registro.chavePend = this.servidorAprovacao.chavePend;
      this.registro.chavePeriodoAquisitivo = this.servidorAprovacao.chavePeriodoAquisitivo;
      this.registro.idReg = this.servidorAprovacao.idReg;
      if (
        this.registro.statusProgramacao.code == "N" &&
        !this.registro.motivoRejeicao
      ) {
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: "Informe o motivo da rejeição",
          life: 3000,
        });
        return;
      }
      if (this.registro.statusProgramacao.code == "N") {
        this.registro.aprovado = false;
        this.registro.proximaSituacao = "REPROVADO";
      } else {
        this.registro.aprovado = true;
        this.registro.proximaSituacao = "APROVADO";
      }
      this.$http
        .post(
          `${baseApiUrl}/lincencaview/validarRejeitarLicenca/${this.registro.idReg}`,
          JSON.stringify(this.registro)
        )
        .then(() => {
          this.$toast.add({
            severity: "success",
            summary: "Sucesso",
            detail: "Registro validado com sucesso",
            life: 3000,
          });
          this.fecharModalValidaEscala();
          this.carregarServidores();
        });
    },
    fecharModalValidaEscala() {
      this.registro = getDefaulValida();
      this.servidorAprovacao = null;
      this.exibirModalAprovacao = false;
    },
    showModal(servidor) {
      this.exibirModalAprovacao = true;
      this.servidorAprovacao = servidor;
    },
    mostrarDetalhes(servidor) {
      this.detalhes = servidor.observacao;
      this.exibirDetalhes = true;
    },
    exibirBotaoAcao(servidor) {
      return (
        (this.mostrarPendentes || this.mostrarDeferidos) && (!servidor.origem || servidor.origem.toUpperCase() !== "SEAP")
      );
    },
    parseAprovador(servidor) {
      if (!servidor || !servidor.aprovador) {
        return null;
      }
      if (typeof servidor.aprovador === "string") {
        try {
          return JSON.parse(servidor.aprovador);
        } catch (e) {
          return null;
        }
      }
      return servidor.aprovador;
    },
    aprovadorNome(servidor) {
      const aprovador = this.parseAprovador(servidor);
      return aprovador ? aprovador.nome : "";
    },
    aprovadorSetor(servidor) {
      const aprovador = this.parseAprovador(servidor);
      return aprovador ? aprovador.nomeSetor : "";
    },

    calcularTotalDias() {
      this.listaServidores.content.forEach((servidor) => {
        let startDate = moment(servidor.dataInicio, "DD/MM/YYYY");
        let endDate = moment(servidor.dataFim, "DD/MM/YYYY");
        servidor.totalDias = endDate.diff(startDate, "days") + 1;
      });
    },
    async carregarServidores(size = 10, page = 0) {
      if (!this.orgaoSelecionado) {
        this.$toast.add({
          severity: "error",
          summary: "Seleção de Orgao Obrigatório, Por favor Selecione um Orgão",
          life: 3000,
        });
        return;
      }

      if (!this.situacaoConsultada) {
        return;
      }

      let bodyRequest = {
        matricula: this.matricula,
        numeroVinculo: this.vinculo,
        seapOrgao: this.orgaoSelecionado.codgSeap,
        seapUnidade: this.unidadeSelecionado
          ? this.unidadeSelecionado.codgSeap
          : null,
        situacao: this.situacaoConsultada,
        filtro: this.filtro,
      };

      try {
        const res = await this.$http.post(
          `${baseApiUrl}/lincencaview/listaOrgaoSetor?page=${page}&size=${size}`,
          JSON.stringify(bodyRequest)
        );
        this.listaServidores = res.data;
        this.calcularTotalDias();

        const resMot = await this.$http.get(
          `${baseApiUrl}/lincencaview/validar/motivo/rejeicao`
        );
        this.motivoRejeicao = resMot.data;
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: "Erro ao carregar servidores",
          detail: error.message,
          life: 3000,
        });
      }
    },
    carregarUnidades() {
      this.unidadeSelecionado = null;
      if (this.orgaoSelecionado) {
        this.$http
          .get(
            `${baseApiUrl}/feriasview/unidades/${this.orgaoSelecionado.idenOrgao}`
          )
          .then((res) => {
            this.listaUnidades = res.data.map(function (element) {
              return {
                ...element,
                labelDropDaw: element.codgSeap + " - " + element.siglUnidade,
              };
            });
          });
      } else {
        this.$toast.add({
          severity: "error",
          summary: "Seleção de Orgao Obrigatório, Por favor Selecione um Orgão",
          life: 3000,
        });
        return;
      }
    },
    limparLista() {
      this.listaServidores = [];
      this.situacaoConsultada = null;
    },
    clicouOrgao() {
      this.limparLista();
      this.carregarUnidades();
    },

    clicouBuscar() {
      if (!this.orgaoSelecionado) {
        this.$toast.add({
          severity: "error",
          summary: "Seleção de Orgao Obrigatório, Por favor Selecione um Orgão",
          life: 3000,
        });
        return;
      }
      if (!this.situacaoSelecionada) {
        this.$toast.add({
          severity: "error",
          summary: "Seleção de Situação Obrigatória, Por favor Selecione uma Situação",
          life: 3000,
        });
        return;
      }
      this.situacaoConsultada = this.situacaoSelecionada.value;
      this.carregarServidores();
    },

    carregarOrgaos() {
      this.$http.get(`${baseApiUrl}/feriasview/orgaosperfil`).then((res) => {
        this.listaOrgao = res.data.map(function (element) {
          return {
            ...element,
            labelDropDaw: element.codgSeap + " - " + element.siglUnidade,
          };
        });
      });
    },
  },
  mounted() {
    // Carrega os dados do serviço
    this.carregarOrgaos();
  },
  computed: {
    mostrarPendentes() {
      return this.situacaoConsultada === "PENDENTE";
    },
    mostrarDeferidos() {
      return this.situacaoConsultada === "APROVADO";
    },
  },
};
</script>

<style scoped>
.card-button {
  cursor: pointer;
}

.botao-titulo-status {
  font-size: 15px;
  font-weight: bold;
}

.estiloPendentes {
  background: rgb(219, 171, 81);
  color: aliceblue;
}

.estiloDeferidos {
  background: #0ca852;
  color: aliceblue;
}

.situacaoColunaFeriasAgendamento > div {
  justify-content: center;
}

.botaoColunaSituacaoFeriasAgendamento {
  text-align: center !important;
}
</style>
